import { useEffect, useRef, useState } from "react";

/**
 * Returns a screen-reader announcement string that updates whenever the
 * background-blur boolean transitions. Empty string on initial mount so the
 * paired aria-live region does not announce on first render.
 */
export function useBlurAnnouncement(isBlurEnabled: boolean): string {
  const previous = useRef(isBlurEnabled);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (previous.current !== isBlurEnabled) {
      setMessage(
        isBlurEnabled ? "Background blur on" : "Background blur off"
      );
      previous.current = isBlurEnabled;
    }
  }, [isBlurEnabled]);

  return message;
}
